import {useIntl} from "react-intl";
import {GLTFExporter} from "three/examples/jsm/exporters/GLTFExporter";
import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";

function usePreProcessAsset() {
  const intl = useIntl();

  const exporter = new GLTFExporter();
  const loader = new GLTFLoader();

  const exportGltf = (gltf, successCallback, errorCallback) => {
    exporter.parse(
      gltf.scene,
      exportedGltf => {
        const jsonString = JSON.stringify(exportedGltf);
        successCallback(jsonString);
      },
      () => {},
      () => errorCallback(intl.formatMessage({id: "ID_ERROR_IMPORT_ASSET"})),
    );
  };

  const import3DAsset = url => {
    return new Promise((resolve, reject) => {
      loader.load(
        url,
        gltf => {
          exportGltf(gltf, resolve, reject);
        },
        () => {},
        () => reject(intl.formatMessage({id: "ID_ERROR_IMPORT_ASSET"})),
      );
    });
  };

  const dataURLtoFile = (dataurl, filename) => {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const file = new File([u8arr], filename, {type: mime});
    return file;
  };

  const getSoundDuration = file => {
    return new Promise(resolve => {
      const source = window.URL.createObjectURL(file);
      const audio = new Audio(source);

      audio.addEventListener("loadedmetadata", () => {
        const duration = audio.duration;
        resolve(String(duration));
      });
    });
  };

  const convertVideoFileToUrl = file => {
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const video = document.createElement("video");

      video.onloadedmetadata = function () {
        URL.revokeObjectURL(url);
        resolve(video.duration);
      };

      video.onerror = function () {
        URL.revokeObjectURL(url);
        reject(new Error("Unable to fetch video metadata"));
      };

      video.src = url;
    });
  };

  const getVideoDuration = file => {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      video.src = URL.createObjectURL(file);

      video.onloadedmetadata = function () {
        resolve(video.duration);
      };

      video.onerror = function () {
        reject(new Error("Unable to fetch video metadata"));
      };
    });
  };

  const createVideoThumbnail = (file, time = 0) => {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      video.src = URL.createObjectURL(file);

      video.onloadedmetadata = function () {
        video.currentTime = time;
      };

      video.onseeked = function () {
        context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
        const thumbnail = canvas.toDataURL("image/png");
        resolve(thumbnail);
      };

      video.onerror = function () {
        reject(new Error("Unable to fetch video metadata"));
      };
    });
  };

  return {
    convertVideoFileToUrl,
    createVideoThumbnail,
    getSoundDuration,
    getVideoDuration,
    import3DAsset,
    dataURLtoFile,
  };
}

export default usePreProcessAsset;
